import { CDS_ZINDEX, Flex } from '@revenuemarket/cds';
import { Typography } from 'antd';
import { useRouter } from 'next/router';

interface Props {
  totalLength: number;
  totalAmount: number;
  rightSlot: React.ReactNode;
}

const SelectedSettlementItemFloatBtn: React.FC<Props> = ({
  totalAmount,
  totalLength,
  rightSlot,
}) => {
  const router = useRouter();
  const urlPathFromSettlement = router.asPath.includes('settlement');
  const zIndexBase = CDS_ZINDEX.FLOATING_BUTTON + (urlPathFromSettlement ? 1 : 10000);
  return (
    <Flex
      style={{
        width: 'max-content',
        position: 'fixed',
        top: 70,
        // 중앙 정렬
        left: '50%',
        zIndex: zIndexBase,
        transform: 'translateX(-50%)',
        background: '#F0FFFC',
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.06)',
        borderRadius: 12,
        border: '1px solid rgba(0, 0, 0, 0.15)',
        padding: '8px 16px',
      }}
      gap={16}
      align="center"
    >
      <Typography.Text>{`${totalLength}건 선택됨`}</Typography.Text>

      {rightSlot}
    </Flex>
  );
};

export default SelectedSettlementItemFloatBtn;
